import React from "react";
import { Avatar, Edit, Trash } from "../assets/svg/AllSvg";

const ShareholderCard = ({
  shareholder,
  onEdit,
  onDelete,
  showActions = true,
  className = "",
}) => {
  return (
    <div
      className={`card bg-white border flex justify-between items-start ${className}`}
    >
      <div className="flex items-start space-x-3">
        <Avatar width={45} height={45} />
        <div>
          <p className="sm:text-lg text-sm font-medium">
            {shareholder?.user?.full_name}
          </p>
          <p className="sm:text-sm text-xs max-w-full truncate mb-1">
            {shareholder?.user?.email}
          </p>
          <div className="grid grid-cols-2 gap-1">
            <p className="text-xs text-gray-400 max-w-full truncate">
              Number of Shares:{" "}
              <span className="text-black">
                {shareholder?.number_of_shares ?? 0}
              </span>
            </p>
            <p className="text-xs text-gray-400 max-w-full truncate">
              Issued Share Capital:{" "}
              <span className="text-black">
                {shareholder?.issued_share_capital ?? 0}
              </span>
            </p>
            <p className="text-xs text-gray-400 max-w-full truncate">
              Paid-up Share Capital:{" "}
              <span className="text-black">
                {shareholder?.paid_up_capital ?? 0}
              </span>
            </p>
          </div>
        </div>
      </div>
      {showActions && (
        <div className="flex items-center">
          <button
            type="button"
            className="p-3"
            onClick={() => onEdit?.(shareholder)}
          >
            <Edit width="16" height="20" />
          </button>
          <button
            type="button"
            className="p-3"
            onClick={() => onDelete?.(shareholder?.id, "shareholder")}
          >
            <Trash width="16" height="20" />
          </button>
        </div>
      )}
    </div>
  );
};

export default ShareholderCard;
